var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTopRoi1 = function SvgTopRoi1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#top-roi1_svg__a)",
    d: "M0 0h12v7l-6 4-6-4z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-roi1_svg__a",
    x1: 0.5,
    x2: 6,
    y1: 0,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#F3D278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C48A16"
  })))));
};
export default SvgTopRoi1;